<!-- 预警类型分布 -->
<template>
	<div>
		<dv-border-box-12 class="padding-lr-sm padding-bottom-lg margin-top-xs dayTimeBox">
			<SecondTitle :secTitle="secTitle"></SecondTitle>
			<div class="flex">
			  <Echart
			    :options="options"
			    id="alertType"
			    :height="curHeight+'px'"
			    :width="curWidth+'px'"
			  ></Echart>
			</div>
		</dv-border-box-12>
	</div>
</template>

<script>
import SecondTitle from '../secondTitle.vue';
import Echart from '@/common/echart';
import {getSizeByScreen} from '@/utils/index';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
		secTitle:{
		  title:'预警类型分布'
		},
		options: {
			color:['#F5EF50','#91E679','#11B5EF','#3174FC'],
			tooltip: {
			  trigger: 'item'
			},
			series: [
			{
				name: '访问来源',
				type: 'pie',
				radius: ['30%', '60%'],
				center:['50%','50%'],
				data: [
					{value: 0, name: '机器人'},
					{value: 0, name: '电池'},
					{value: 0, name: '充电机'},
					{value: 0, name: '摄像头'},
				]
			},
			] 
		},
    };
  },
  watch:{
  	  curWidth:{
  	    handler (newData) {
  	      this.curWidth = 400;
  	      //适配代码
  	      // this.curWidth = getSizeByScreen(400);
  	    },
  	    immediate: true,
  	    deep: true
  	  },
  	  curHeight:{
  	    handler (newData) {
  	      this.curHeight = 180;
  	      //适配代码
  	      // this.curHeight = getSizeByScreen(180);
  	    },
  	    immediate: true,
  	    deep: true
  	  }
  },
  components: {
	  SecondTitle,
	  Echart
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectAlarmTypeFrom(data);
    },
    selectAlarmTypeFrom(data={}){
      let _this = this;
      let params = {};
			if(data){
				params = {
					"enCode":"TiDB-shengshiqu-shishigaojing",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-shishigaojing"//TiDB-省市区-预警类型分布
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
					console.log("预警分布类型",res)

					this.options.series[0].data = 	[
						{value: res[0].alarmTimesNum, name: '机器人'},
						{value: res[1].alarmTimesNum, name: '电池'},
						{value: res[2].alarmTimesNum, name: '充电机'},
						{value: res[3].alarmTimesNum, name: '摄像头'},
					]
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
	.dayTimeBox{
		width: 463px;
		height: 240px;
	}
</style>